import type { PortableTextBlock, PortableTextComponents } from '@portabletext/react';
import { PortableText } from '@portabletext/react';

interface FaqContentProps {
  faq: {
    question: string;
    answer: PortableTextBlock[];
  };
}

const simpleFaqComponents: PortableTextComponents = {
  block: {
    normal: ({ children }) => (
      <p className="self-stretch pl-6 font-normal text-base text-white leading-snug opacity-60 md:text-[14px]">
        {children}
      </p>
    ),
  },
  list: {
    bullet: ({ children }) => <ul className="space-y-2 self-stretch pl-6">{children}</ul>,
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="flex items-start gap-2">
        <span className="mt-2 inline-block h-1 w-1 flex-shrink-0 rounded-full bg-white opacity-60" />
        <span className="flex-1 text-base text-white opacity-60">{children}</span>
      </li>
    ),
  },
  marks: {
    strong: ({ children }) => <span className="font-bold text-white">{children}</span>,
    link: ({ children, value }) => (
      <a href={value.href} className="text-blue-500 hover:text-blue-700">
        {children}
      </a>
    ),
    bullet: ({ children }) => <li className="list-disc pl-6">{children}</li>,
  },
};

export default function FaqContent({ faq }: FaqContentProps) {
  return (
    <div className="relative flex flex-col items-start justify-start self-stretch rounded-2xl">
      <div className="flex flex-col items-start justify-start self-stretch rounded-2xl">
        <div className="flex flex-col items-start justify-start gap-2 self-stretch">
          <div className="inline-flex items-start justify-start gap-4 self-stretch">
            <div className="mt-[10px] h-2 w-2 flex-shrink-0 rounded-full bg-[#0061ff] md:mt-2" />
            <div className="justify-start font-medium text-white text-xl leading-7 md:text-base">{faq.question}</div>
          </div>
          <PortableText value={faq.answer} components={simpleFaqComponents} />
        </div>
      </div>
    </div>
  );
}
